<template>
    <div class="relative w-full px-2.5 pt-4 lg:px-0 lg:pt-7">
        <div
            class="mx-auto my-0 flex max-h-full max-w-[1251px] lg:mx-auto lg:mb-[95px] lg:mt-[86px] lg:px-[10px]"
        >
            <div
                class="mb-5 grid w-full grid-cols-1 gap-x-[15px] gap-y-[10px] md:grid-cols-2 lg:mb-0 lg:hidden lg:grid-cols-4 lg:gap-x-[40px] 2xl:gap-x-[65px]"
            >
                <div
                    v-for="(item, index) in intersectionSportVirtualItems"
                    :key="index"
                    @click="handleSportClick(item)"
                >
                    <ThaBlocksCardSportMobile :item="item" />
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import {
    useAlertStore,
    useModalStore,
    useUserStore,
    useSportsStore,
} from '~/stores'
const alertStore = useAlertStore()
const { t } = useI18n({})
const localePath = useLocalePath()
const useUserStoreInstance = useUserStore()
const useModalStoreInstance = useModalStore()

const { isMobile } = useDevice()

const useSportsStoreInstance = useSportsStore()
const { intersectionSportVirtualItems } = storeToRefs(useSportsStoreInstance)

const headers = useRequestHeaders(['cookie'])
const handleSportClick = async (item = {}) => {
    // check auth
    if (item.require_auth && !useUserStoreInstance.isLoggedIn) {
        useModalStoreInstance.showLoginModal = true
        return
    }
    // if desktop rout to page
    if (!isMobile) {
        navigateTo(localePath(item.page_url))
        return
    }
    // if mobile get urlfrom api, open new tab
    try {
        const newtab = window.open('', '_blank')
        const { data } = await useFetch(item.api_url, {
            headers,
            baseURL: '/api/v1',
        })
        if (data.value.status === 'OK') {
            const { url } = data.value.data
            if (newtab) newtab.location.href = url
            // setTimeout(() => {
            //     const popup = window.open(url, '_blank')
            //     if (!popup) {
            //         alertStore.showMessageError({
            //             value: {
            //                 statusCode: 'SHOW_MESSAGE',
            //                 message: t('error.allow_popup'),
            //             },
            //         })
            //         window.open(url, '_blank')
            //     }
            // })
        } else {
            if (newtab) newtab.close()
            alertStore.showMessageError({
                value: {
                    statusCode: 'SHOW_MESSAGE',
                    message: t('error.server_is_busy'),
                },
            })
        }
    } catch (error) {
        if (newtab) newtab.close()
        console.error(error)
    }
}
onMounted(async () => {
    await useSportsStoreInstance.execute()
})
</script>
